import { useCallback, useEffect, useRef, useState } from 'react'
import { APPS_HEIGHT_MAX, APPS_HEIGHT_MIN, APPS_HEIGHT_STORAGE_KEY, readStoredAppsHeight } from './appsSectionTokens.js'
import { appsResizeKeyDown } from './appsResizeKeyDown.js'

export function useAppsSectionResize() {
  const [appsHeightPx, setAppsHeightPx] = useState(readStoredAppsHeight)
  const resizeStartRef = useRef(null)

  useEffect(() => {
    try {
      localStorage.setItem(APPS_HEIGHT_STORAGE_KEY, String(appsHeightPx))
    } catch {
      /* ignore */
    }
  }, [appsHeightPx])

  const onResizePointerDown = useCallback((e) => {
    e.preventDefault()
    e.stopPropagation()
    resizeStartRef.current = { pointerId: e.pointerId, startY: e.clientY, startH: appsHeightPx }
    e.currentTarget.setPointerCapture(e.pointerId)
  }, [appsHeightPx])

  const onResizePointerMove = useCallback((e) => {
    const s = resizeStartRef.current
    if (s == null || e.pointerId !== s.pointerId) return
    const dy = e.clientY - s.startY
    setAppsHeightPx(Math.round(Math.min(APPS_HEIGHT_MAX, Math.max(APPS_HEIGHT_MIN, s.startH + dy))))
  }, [])

  const onResizePointerUp = useCallback((e) => {
    const s = resizeStartRef.current
    if (s == null || e.pointerId !== s.pointerId) return
    resizeStartRef.current = null
    try {
      e.currentTarget.releasePointerCapture(e.pointerId)
    } catch {
      /* ignore */
    }
  }, [])

  const onResizeKeyDown = useCallback((e) => appsResizeKeyDown(e, appsHeightPx, setAppsHeightPx), [appsHeightPx])

  return { appsHeightPx, onResizePointerDown, onResizePointerMove, onResizePointerUp, onResizeKeyDown }
}
